// src/SweetTradingPro.jsx
import React, { useEffect, useMemo, useRef, useState } from "react";
import { motion, useInView, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";

import { auth } from "./firebase";
import { createUserWithEmailAndPassword, updateProfile } from "firebase/auth";

import PurchasePopup from "./PurchasePopup";
import logoST from "./assets/logo-st.png";

import ForexMw from "./assets/instafxwall.jpg";
import forexmartLogo from "./assets/Dakar.svg";

import { FaRobot, FaChartLine, FaBolt, FaStar, FaBars } from "react-icons/fa";

import option1 from "./assets/option-1.svg";
import option4 from "./assets/option-4.svg";
import option6 from "./assets/option-6.svg";
import option7 from "./assets/option-7.svg";
import option8 from "./assets/option-8.svg";
import option9 from "./assets/option-9.svg";
import option10 from "./assets/option-10.svg";
import option11 from "./assets/option-11.svg";

/* ---------------- COPY STATICO – TEDESCO ---------------- */
const DE_COPY = {
  heroTitle: "EINE NEUE TRADING-GENERATION",
  heroSubtitle:
    "98 % aller Trader scheitern. Aber nicht heute, nicht mehr. Wir sind endlich hier, um diese Statistik für immer zu ändern – schließ dich jetzt der Revolution an.",
  buttonText: "Entdecke Candy Bot",
  buttonLink: "#promo-purchase",

  clockSection: {
    title: "jede sekunde zählt",
    line1:
      "Jede Sekunde, 24 Stunden am Tag, 5 Tage die Woche analysiert unser Bot die Märkte",
    line2: "um die besten Trading-Chancen zu identifizieren.",
  },

  whySection: {
    title: "Sweet und kraftvoll",
    description:
      "Gibt es etwas Süßeres als Geld? Ja: leicht verdientes Geld. Leider existiert „leichtes Geld“ nicht – aber Candy Bot ist da, um den Deal zu versüßen und die harte Arbeit für dich zu übernehmen.",
    features: [
      {
        title: "KI-Power",
        highlight: "Motor des unvermeidlichen Wandels",
        description:
          "Candy Bot nutzt fortschrittliche KI mit proprietären neuronalen Netzen, um die globalen Märkte in Echtzeit zu analysieren. Unser System kombiniert Deep Learning, Mustererkennung und prädiktive Analysen, um sich dynamisch an Marktvolatilität anzupassen.",
        image: "/ai.jpg",
        icon: "FaRobot",
      },
      {
        title: "Außergewöhnliche Ergebnisse",
        highlight: "Einzigartig, zuerst, am stärksten",
        description:
          "Entwickelt, um die besten Chancen in reale Ergebnisse zu verwandeln. Optimiert, um Fehler zu minimieren und Gewinne zu maximieren. Unsere adaptiven Algorithmen verfeinern kontinuierlich die Strategien und setzen robuste Risikomanagement-Protokolle durch.",
        image: "/performance.jpg",
        icon: "FaChartLine",
      },
      {
        title: "Marktoptimiert",
        highlight: "Timing ist alles",
        description:
          "Forex, Aktien oder Krypto – jedes Modell ist auf den Kontext spezialisiert, in dem es agiert, damit es immer zum richtigen Zeitpunkt zuschlagen kann.",
        image: "/forex.jpg",
        icon: "FaBolt",
      },
    ],
  },

  processSection: {
    title: "Der 3-Schritte-Prozess",
    subtitle:
      "Von der Registrierung bis zur Gewinnauszahlung – einfach und transparent",
    steps: [
      {
        title: "Wähle deinen Plan",
        description:
          "Wähle den Plan, der am besten zu deinen Zielen passt, und schließe den Kauf mit wenigen Klicks ab.",
        timeLabel: "2 Minuten",
      },
      {
        title: "Starte mit dem Trading",
        description:
          "Starte mit dem Trading, indem du den Anweisungen folgst, die in deinem ausgewählten Plan enthalten sind. Unser System führt dich Schritt für Schritt.",
        timeLabel: "Variabel",
      },
      {
        title: "Gewinne auszahlen",
        description:
          "Erhalte deine Gewinne direkt auf dein Bankkonto oder dein bevorzugtes Wallet innerhalb von 24–48 Stunden.",
        timeLabel: "24–48 Stunden",
      },
    ],
  },

  promo: {
    badge: "Spezialangebot",
    title: "Candy Bot",
    subtitle:
      'Zur Feier des Launches unseres neuen Bots und um dieses wichtige Etappenziel zu markieren, haben wir beschlossen, ihn zu einem unschlagbaren Preis anzubieten, <strong>nur für kurze Zeit verfügbar</strong>.',
    cardTitle: "Candy Bot Standard",
    cardSubtitle: "Starte deine Reise noch heute",
    newBadge: "NEU",
    oldPrice: "$99",
    newPrice: "$0",
    limitedNote: "Zeitlich begrenztes Angebot",
    features: [
      "Voller Bot-Zugriff",
      "24/7-Support",
      "Erweitertes Dashboard",
      "KI-gestützte Analysen",
    ],
    button: "Candy Bot entdecken",
    promoTitle: "Zeitlich begrenzte Aktion",
    promoText:
      "Registriere dich <strong>jetzt</strong> und erhalte vollen Zugriff – keine Zahlung, keine Verpflichtung.",
    endsSoon: "Angebot endet in Kürze!",
    benefits: [
      "✅ Keine Kosten",
      "✅ Jederzeit kündbar",
      "✅ Sofortige Aktivierung",
      "✅ Kostenlose Updates",
    ],
    guarantee: "🔒 Performance-Garantie",
  },

  compareSection: {
    planTitle: "Candy Bot Standard",
    planTSubtitle:
      "Von traditionellen Lösungen bis zu fortgeschrittener KI – wähle die perfekte Version für deine Bedürfnisse",
    planSubtitle: "Alles, was du für den Start brauchst",
    priceFree: "$0",
    priceOld: "$99",
    offerNote: "Zeitlich begrenztes Angebot",
    features: [
      "7 Forex-Paare",
      "24/7-Support",
      "Schritt-für-Schritt-Anleitung",
      "70 % Gewinnbeteiligung",
      "Mindestinvestition $100",
    ],
    button: "Jetzt kostenlos sichern",
    popupTitle: "Du beantragst Candy Bot Standard",
    popupSubtitle: "Gib deine Daten ein, um das kostenlose Angebot zu nutzen",
    form: {
      name: "Vollständiger Name",
      email: "E-Mail",
      password: "Passwort",
      confirmPassword: "Passwort bestätigen",
      submit: "Registrieren & Zugang erhalten",
    },
    disclaimer: 'Mit dem Klick auf „Registrieren“ akzeptierst du unsere',
    terms: "Nutzungsbedingungen",
    privacy: "Datenschutzerklärung",
  },

  comingSoonSection: {
    badge: "BALD VERFÜGBAR",
    title: "Candy Bot Pro",
    subtitle: "KI-Trading der nächsten Generation",
    priceLabel: "Bald verfügbar",
    priceDescription: "Preis wird in Kürze bekanntgegeben",
    features: [
      "KI-Modell für Aktien/Forex/Krypto",
      "3 verschiedene Märkte",
      "Priorisierter 24/7-Support",
      "Schritt-für-Schritt-Setup-Anleitung",
      "70 % Gewinnbeteiligung",
      "Mindestinvestition $500",
    ],
    buttonText: "In Kürze verfügbar",
  },

  faq: {
    title: "Häufig gestellte Fragen",
    description: "Alle Antworten auf die wichtigsten Fragen zu unserem Service",
    items: [
      {
        question: "Wie beginne ich mit der Nutzung von Candy Bot?",
        answer:
          "Klicke einfach auf „Kostenlos testen“ bzw. auf die Schaltfläche auf dieser Seite und folge dem Registrierungsprozess.",
      },
      {
        question: "Was, wenn ich keine Ahnung von Trading habe?",
        answer:
          "Kein Problem: Candy Bot wurde für alle entwickelt, die in die Trading-Welt einsteigen möchten, ohne die typischen Risiken – oder für alle, die sich ein zusätzliches monatliches Einkommen auf einfache und möglichst automatische Weise aufbauen möchten.",
      },
      {
        question: "Wie hoch ist die durchschnittliche monatliche Rendite?",
        answer:
          "Die Rendite hängt von den Marktbedingungen und dem gewählten Plan ab. Mit dem richtigen Kapital und dem passenden Bot ist es möglich, ein vollständiges monatliches Einkommen zu generieren.",
      },
      {
        question: "Für wen sind diese Bots gedacht?",
        answer:
          "Ideal für jede Person ab 18 Jahren, die mit weniger Stress traden oder das monatliche Einkommen fast automatisch steigern möchte.",
      },
      {
        question: "Kann ich mehrere Bots gleichzeitig nutzen?",
        answer:
          "Ja! Du kannst mehrere Bots aktivieren, aber jeder muss auf einem separaten Konto laufen, um Konflikte zu vermeiden.",
      },
      {
        question: "Was ist Forex?",
        answer:
          "Forex ist der Markt, auf dem Währungen wie Euro und US-Dollar gehandelt werden. Es ist der größte Markt der Welt, 24/5 geöffnet, und ermöglicht es dir, von Wechselkursbewegungen zu profitieren.",
      },
    ],
  },

  legalSupport: {
    sectionTitle: "Rechtliches & Support",
    terms: "Nutzungsbedingungen",
    privacy: "Datenschutz",
    emailLabel: "E-Mail-Support:",
    email: "support@sweet-trading.com",
    chatLabel: "Chat mit uns:",
    replyTime: "Wir antworten in der Regel innerhalb weniger Minuten",
  },

  footer: {
    copyright: "© 2024–2025 Sweet Trading Inc. Alle Rechte vorbehalten. 🍬",
    disclaimer:
      "Alle Informationen auf dieser Website dienen ausschließlich Bildungszwecken im Zusammenhang mit dem Handel an Finanzmärkten und stellen keine spezifische Anlageempfehlung, Handelsempfehlung, Analyse einer Anlagegelegenheit oder sonstige allgemeine Empfehlung zum Handel mit Finanzinstrumenten dar. Die Informationen auf dieser Website sind nicht für Einwohner von Ländern oder Jurisdiktionen bestimmt, in denen ihre Verbreitung oder Nutzung gegen lokale Gesetze oder Vorschriften verstoßen würde.",
  },

  headerLabels: {
    support: "Support",
    faq: "FAQ",
    howItWorks: "Der 3-Schritte-Prozess",
    bots: "Bots",
    login: "Login",
  },

  brokerSection: {
    titleA: "Vertraut von",
    titleB: "tausenden Tradern weltweit",
    subtitle:
      "Zuverlässigkeit, Transparenz und erstklassige Ausführung – über unsere regulierten Partner-Entitäten.",
    captionA: "InstaForex.com",
    captionB:
      "Handele smarter mit fortschrittlichen Tools, wettbewerbsfähigen Spreads und globaler Regulierung.",
    microDisclaimer:
      "Trading ist mit Risiko verbunden. Diese Inhalte sind werblich und stellen keine Finanzberatung dar.",
  },
};

/* ---------------- UTILS ---------------- */
const LANGS = [
  { code: "en", label: "EN", flag: "🇬🇧", href: "/" },
  { code: "it", label: "IT", flag: "🇮🇹", href: "/it" },
  { code: "de", label: "DE", flag: "🇩🇪", href: "/de" },
  { code: "es", label: "ES", flag: "🇪🇸", href: "/es" },
  { code: "fr", label: "FR", flag: "🇫🇷", href: "/fr" },
  { code: "ar", label: "AR", flag: "🇸🇦", href: "/ar" },
];

const addPassive = (el, type, handler) => {
  if (!el) return () => {};
  el.addEventListener(type, handler, { passive: true });
  return () => el.removeEventListener(type, handler);
};

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia("(max-width: 768px)");
    const update = () => setIsMobile(mq.matches);
    update();
    mq.addEventListener?.("change", update);
    return () => mq.removeEventListener?.("change", update);
  }, []);
  return isMobile;
};

const isIOSDevice = () =>
  /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

/** iOS viewport lock */
function useIOSViewportLock() {
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    const iOS = isIOSDevice();
    setIsIOS(iOS);

    const setLocked = () => {
      const vh = window.visualViewport?.height ?? window.innerHeight;
      document.documentElement.style.setProperty("--vh-locked", `${vh}px`);
      document.documentElement.style.setProperty("--vh-locked-safe", `${vh}px`);
    };

    const setDynamicBase = () => {
      const supportsLVH = CSS?.supports?.("height", "100lvh");
      document.documentElement.style.setProperty(
        "--vh-dynamic",
        supportsLVH ? "100lvh" : "100svh"
      );
    };

    setDynamicBase();
    setLocked();

    if (!iOS) {
      const cleanR = addPassive(window, "resize", setDynamicBase);
      const cleanO = addPassive(window, "orientationchange", setDynamicBase);
      return () => {
        cleanR();
        cleanO();
      };
    }

    const onOrient = () => setTimeout(setLocked, 250);
    const onVis = () => setTimeout(setLocked, 150);

    const cleanOrient = addPassive(window, "orientationchange", onOrient);
    document.addEventListener("visibilitychange", onVis, { passive: true });

    return () => {
      cleanOrient();
      document.removeEventListener("visibilitychange", onVis);
    };
  }, []);

  return isIOS;
}

function useLockBodyScroll(locked) {
  useEffect(() => {
    if (!locked) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [locked]);
}

/* ---------------- CLOCK ---------------- */
function ClockWidget() {
  const [time, setTime] = useState(new Date());
  useEffect(() => {
    const id = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(id);
  }, []);
  return (
    <div className="relative flex items-center justify-center w-40 h-40 sm:w-44 sm:h-44 rounded-full bg-slate-800/80 border border-indigo-500/30 shadow-2xl backdrop-blur-sm">
      <div className="text-4xl sm:text-5xl font-mono font-light tracking-tighter bg-gradient-to-r from-indigo-300 to-white bg-clip-text text-transparent">
        {time.toLocaleTimeString()}
      </div>
    </div>
  );
}

/* ---------------- WHY MOBILE ---------------- */
function WhyMobile({ whyCopy, iconMap }) {
  const features = whyCopy?.features || [];
  const [active, setActive] = useState(0);
  const activeItem = features[active] ?? null;

  if (!features.length) return null;

  return (
    <section id="why" className="relative px-4 py-10 text-white md:hidden overflow-hidden">
      {/* SFONDO DINAMICO */}
      <div className="absolute inset-0 pointer-events-none">
        <AnimatePresence mode="wait">
          {activeItem?.image && (
            <motion.div
              key={active}
              initial={{ opacity: 0, scale: 1.05 }}
              animate={{ opacity: 0.55, scale: 1 }}
              exit={{ opacity: 0, scale: 1.02 }}
              transition={{ duration: 0.45, ease: [0.25, 1, 0.5, 1] }}
              className="absolute inset-0"
            >
              <img
                src={activeItem.image}
                alt={activeItem.title}
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/85 via-slate-950/85 to-slate-950/95" />
            </motion.div>
          )}
        </AnimatePresence>

        <div className="absolute -top-20 -left-10 w-40 h-40 rounded-full bg-indigo-500/25 blur-3xl" />
        <div className="absolute bottom-0 right-0 w-52 h-52 rounded-full bg-sky-400/15 blur-3xl" />
      </div>

      {/* CONTENUTO */}
      <div className="relative z-10 max-w-md mx-auto">
        <div className="text-center mb-6">
          <span className="inline-block text-[0.65rem] uppercase tracking-[0.2em] text-indigo-300 bg-indigo-500/10 px-3 py-1 rounded-full mb-3">
            {whyCopy.title || "Warum Sweet Trading"}
          </span>
          <h2 className="text-2xl font-bold text-white mb-2">
            <span className="bg-gradient-to-r from-white via-indigo-100 to-indigo-300 bg-clip-text text-transparent">
              Sweet &amp; kraftvoll
            </span>
          </h2>
          <p className="text-sm text-slate-100/85 leading-relaxed">{whyCopy.description}</p>
        </div>

        <div className="flex gap-2 overflow-x-auto pb-2 mb-4 scrollbar-thin scrollbar-thumb-slate-700/70">
          {features.map((feat, idx) => {
            const Icon = iconMap[feat.icon];
            const isActive = idx === active;
            return (
              <button
                key={idx}
                type="button"
                onClick={() => setActive(idx)}
                className={`flex items-center gap-2 px-3 py-2 rounded-full border text-xs font-medium flex-shrink-0 transition-all ${
                  isActive
                    ? "bg-white text-slate-900 border-white shadow-md shadow-indigo-500/30"
                    : "bg-transparent text-slate-100 border-slate-400/70 hover:border-indigo-400/70 hover:bg-slate-900/30"
                }`}
              >
                {Icon && (
                  <Icon
                    className={`text-sm ${isActive ? "text-indigo-600" : "text-indigo-300"}`}
                  />
                )}
                <span className="text-[0.8rem] leading-snug">{feat.title}</span>
              </button>
            );
          })}
        </div>

        <AnimatePresence mode="wait">
          {activeItem && (
            <motion.div
              key={active}
              initial={{ opacity: 0, y: 18, scale: 0.97, filter: "blur(5px)" }}
              animate={{ opacity: 1, y: 0, scale: 1, filter: "blur(0px)" }}
              exit={{ opacity: 0, y: -12, scale: 0.98, filter: "blur(3px)" }}
              transition={{ duration: 0.4, ease: [0.25, 1, 0.5, 1] }}
              className="bg-slate-900/20 backdrop-blur-sm border border-indigo-500/50 rounded-2xl p-4 shadow-xl"
            >
              <div className="flex items-center gap-3 mb-3">
                {(() => {
                  const Icon = iconMap[activeItem.icon];
                  return Icon ? (
                    <div className="w-10 h-10 rounded-xl bg-indigo-500/20 border border-indigo-300/40 flex items-center justify-center flex-shrink-0">
                      <Icon className="text-lg text-white" />
                    </div>
                  ) : null;
                })()}

                <div className="text-left">
                  <p className="text-[0.65rem] uppercase tracking-[0.18em] text-indigo-300/85 mb-1">
                    {activeItem.highlight}
                  </p>
                  <h3 className="text-base font-semibold leading-snug">{activeItem.title}</h3>
                </div>
              </div>

              <p className="text-sm text-slate-100/90 leading-relaxed mb-3">
                {activeItem.description}
              </p>

              {/* LINK (fix: niente duplicati / niente "...") */}
              <Link
                to="/strategy"
                className="inline-flex items-center gap-1.5 text-sm font-medium text-indigo-200 hover:text-white transition"
              >
                Mehr erfahren
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-3.5 h-3.5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </Link>

              <div className="flex items-center justify-between pt-3 text-[0.7rem] text-slate-300/80">
                <span>
                  Funktion {active + 1} / {features.length}
                </span>
                <div className="flex gap-1.5">
                  {features.map((_, i) => (
                    <span
                      key={i}
                      className={`w-1.5 h-1.5 rounded-full transition-all ${
                        i === active ? "bg-indigo-400 scale-110" : "bg-slate-500/60"
                      }`}
                    />
                  ))}
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </section>
  );
}

/* ---------------- WHY TABS (DESKTOP) ---------------- */
function WhyTabs({ whyCopy, iconMap }) {
  const features = whyCopy?.features || [];
  const [active, setActive] = useState(0);
  const activeItem = features[active] ?? null;

  if (!features.length) return null;

  return (
    <section id="why" className="relative py-14 md:py-20 px-4 text-white overflow-hidden">
      <div className="pointer-events-none absolute inset-0">
        <AnimatePresence mode="wait">
          {activeItem?.image && (
            <motion.div
              key={active}
              initial={{ opacity: 0, scale: 1.05 }}
              animate={{ opacity: 0.5, scale: 1 }}
              exit={{ opacity: 0, scale: 1.02 }}
              transition={{ duration: 0.5, ease: [0.25, 1, 0.5, 1] }}
              className="absolute inset-0"
            >
              <img
                src={activeItem.image}
                alt={activeItem.title}
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-br from-slate-950/90 via-slate-950/80 to-indigo-950/85" />
            </motion.div>
          )}
        </AnimatePresence>

        <div className="absolute -top-40 -left-10 w-72 h-72 rounded-full bg-indigo-500/25 blur-3xl" />
        <div className="absolute bottom-0 right-0 w-80 h-80 rounded-full bg-sky-400/15 blur-3xl" />
      </div>

      <div className="relative z-10 max-w-6xl mx-auto flex flex-col md:flex-row gap-10 md:gap-14 items-stretch">
        <div className="w-full md:w-5/12 flex flex-col justify-center">
          <span className="inline-block text-[0.65rem] uppercase tracking-[0.25em] text-indigo-300 bg-indigo-500/10 px-3 py-1 rounded-full mb-4">
            {whyCopy.title || "Warum Sweet Trading"}
          </span>

          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 leading-tight">
            <span className="bg-gradient-to-r from-white via-indigo-100 to-indigo-300 bg-clip-text text-transparent">
              Sweet &amp; kraftvoll
            </span>
          </h2>

          <p className="text-sm sm:text-base text-slate-200/85 leading-relaxed mb-6">
            {whyCopy.description}
          </p>

          <div className="flex flex-wrap gap-3">
            {features.map((feat, idx) => {
              const Icon = iconMap[feat.icon];
              const isActive = idx === active;
              return (
                <button
                  key={idx}
                  type="button"
                  onClick={() => setActive(idx)}
                  className={`inline-flex items-center gap-2 px-3.5 py-2 rounded-full border text-xs sm:text-sm font-medium transition-all ${
                    isActive
                      ? "bg-white text-slate-900 border-white shadow-lg shadow-indigo-500/30"
                      : "bg-slate-900/60 text-slate-200 border-slate-600/80 hover:border-indigo-400/70 hover:bg-slate-800/80"
                  }`}
                >
                  {Icon && (
                    <Icon className={`text-sm ${isActive ? "text-indigo-600" : "text-indigo-300"}`} />
                  )}
                  <span>{feat.title}</span>
                </button>
              );
            })}
          </div>
        </div>

        <div className="w-full md:w-7/12">
          <AnimatePresence mode="wait">
            {activeItem && (
              <motion.div
                key={active}
                initial={{ opacity: 0, y: 24, scale: 0.97, filter: "blur(6px)" }}
                animate={{ opacity: 1, y: 0, scale: 1, filter: "blur(0px)" }}
                exit={{ opacity: 0, y: -18, scale: 0.98, filter: "blur(4px)" }}
                transition={{ duration: 0.45, ease: [0.25, 1, 0.5, 1] }}
                className="relative rounded-2xl overflow-hidden border border-indigo-500/50 bg-slate-900/80 shadow-2xl"
              >
                {activeItem.image && (
                  <div className="absolute inset-0 opacity-30">
                    <img
                      src={activeItem.image}
                      alt={activeItem.title}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-gradient-to-br from-slate-950/80 via-slate-950/60 to-slate-900/80" />
                  </div>
                )}

                <div className="relative z-10 p-6 sm:p-7 md:p-8 flex flex-col gap-4">
                  <div className="flex items-center gap-3">
                    {(() => {
                      const Icon = iconMap[activeItem.icon];
                      return Icon ? (
                        <div className="w-11 h-11 rounded-xl bg-indigo-500/20 border border-indigo-300/40 flex items-center justify-center">
                          <Icon className="text-xl text-white" />
                        </div>
                      ) : null;
                    })()}

                    <div className="text-left">
                      <p className="text-[0.7rem] uppercase tracking-[0.2em] text-indigo-300/80 mb-1">
                        {activeItem.highlight}
                      </p>
                      <h3 className="text-lg sm:text-2xl font-semibold">{activeItem.title}</h3>
                    </div>
                  </div>

                  <p className="text-sm sm:text-base text-slate-100/90 leading-relaxed">
                    {activeItem.description}
                  </p>

                  {/* LINK (fix) */}
                  <Link
                    to="/strategy"
                    className="inline-flex items-center gap-1.5 text-sm font-medium text-indigo-200 hover:text-white transition"
                  >
                    Mehr erfahren
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-3.5 h-3.5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </Link>

                  <div className="flex items-center justify-between pt-2 text-xs text-slate-300/80">
                    <span>
                      Funktion {active + 1} / {features.length}
                    </span>
                    <div className="flex gap-1.5">
                      {features.map((_, i) => (
                        <span
                          key={i}
                          className={`w-1.5 h-1.5 rounded-full transition-all ${
                            i === active ? "bg-indigo-400 scale-110" : "bg-slate-500/60"
                          }`}
                        />
                      ))}
                    </div>
                  </div>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>
    </section>
  );
}

/* =========================
   COMPONENTE PRINCIPALE
   ========================= */
export default function SweetTradingPro() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showLangMenu, setShowLangMenu] = useState(false);

  const isMobile = useIsMobile();
  const isIOS = useIOSViewportLock();

  useLockBodyScroll(isMobileMenuOpen);

  const mobileLangMenuRef = useRef(null);
  const desktopLangMenuRef = useRef(null);

  // Icon map
  const iconMap = { FaRobot, FaChartLine, FaBolt };

  // Copy mapping
  const heroCopy = {
    title: DE_COPY.heroTitle || "",
    subtitle: DE_COPY.heroSubtitle || "",
    buttonText: DE_COPY.buttonText || "Mehr erfahren",
    buttonLink: DE_COPY.buttonLink || "#promo-purchase",
  };
  const clockCopy = DE_COPY.clockSection || { title: "", line1: "", line2: "" };
  const whyCopy = DE_COPY.whySection || { title: "", description: "", features: [] };
  const processCopy = DE_COPY.processSection || { title: "", subtitle: "", steps: [] };
  const promoCopy = DE_COPY.promo || {};
  const compareCopy = DE_COPY.compareSection || { features: [], form: {} };
  const popupCopy = DE_COPY.compareSection; // contiene popupTitle, popupSubtitle, form, disclaimer, terms, privacy

  const comingCopy = DE_COPY.comingSoonSection || { features: [] };
  const faqCopy = DE_COPY.faq || { items: [] };
  const legalCopy = DE_COPY.legalSupport || {};
  const footerCopy = DE_COPY.footer || {};
  const headerCopy = DE_COPY.headerLabels || {};
  const brokerCopy = DE_COPY.brokerSection || {};

  const content = {
    ...processCopy,
    steps: (processCopy.steps || []).map((step, i) => ({
      number: String(i + 1),
      title: step.title || "",
      description: step.description || "",
      timeLabel: step.timeLabel || "",
    })),
  };
  const safeSteps = content.steps || [];
  const handleRegister = async ({ firstName, lastName, email, password }) => {
  try {
    const cred = await createUserWithEmailAndPassword(auth, email, password);

    const displayName = `${firstName || ""} ${lastName || ""}`.trim();
    if (displayName) {
      await updateProfile(cred.user, { displayName });
    }

    return cred.user;
  } catch (e) {
    const code = e?.code || "";

    // messaggi user-friendly (DE)
    const msg =
      code === "auth/email-already-in-use"
        ? "Diese E-Mail wird bereits verwendet."
        : code === "auth/invalid-email"
        ? "Ungültige E-Mail-Adresse."
        : code === "auth/weak-password"
        ? "Passwort zu schwach (mind. 6 Zeichen)."
        : "Registrierung fehlgeschlagen. Bitte versuche es erneut.";

    throw new Error(msg);
  }
};


  // header vars (altezza header per scroll-margins)
  useEffect(() => {
    let raf = 0;
    const setVars = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const header = document.getElementById("app-header");
        const headerH = header ? header.offsetHeight : 0;
        document.documentElement.style.setProperty("--headerH", `${headerH}px`);
      });
    };
    setVars();
    const cleanResize = addPassive(window, "resize", setVars);
    const cleanOrient = addPassive(window, "orientationchange", setVars);
    document.addEventListener("visibilitychange", setVars);
    return () => {
      cancelAnimationFrame(raf);
      cleanResize();
      cleanOrient();
      document.removeEventListener("visibilitychange", setVars);
    };
  }, []);

  // Chiudi menu lingua clic fuori + ESC
  useEffect(() => {
    if (!showLangMenu) return;

    const onDown = (e) => {
      const m = mobileLangMenuRef.current;
      const d = desktopLangMenuRef.current;
      if (m?.contains(e.target) || d?.contains(e.target)) return;
      setShowLangMenu(false);
    };

    const onKey = (e) => {
      if (e.key === "Escape") setShowLangMenu(false);
    };

    document.addEventListener("mousedown", onDown);
    document.addEventListener("touchstart", onDown, { passive: true });
    window.addEventListener("keydown", onKey);

    return () => {
      document.removeEventListener("mousedown", onDown);
      document.removeEventListener("touchstart", onDown);
      window.removeEventListener("keydown", onKey);
    };
  }, [showLangMenu]);

  // Se esci da mobile, chiudi menu mobile
  useEffect(() => {
    if (!isMobile && isMobileMenuOpen) setIsMobileMenuOpen(false);
  }, [isMobile, isMobileMenuOpen]);

  // Clock in-view
  const clockRef = useRef(null);
  const clockInView = useInView(clockRef, { once: true, amount: 0.4 });

  const clockItemVariants = {
    hidden: { opacity: 0, y: 16, filter: "blur(0.5px)" },
    visible: {
      opacity: 1,
      y: 0,
      filter: "blur(0px)",
      transition: { duration: 0.7, ease: [0.25, 1, 0.5, 1] },
    },
  };

  const clockUnderlineVariants = {
    hidden: { opacity: 0, scaleX: 0 },
    visible: { opacity: 1, scaleX: 1, transition: { duration: 0.45, ease: "easeOut" } },
  };

  // Particelle clock (stabili)
  const clockParticles = useMemo(() => {
    return Array.from({ length: 3 }).map(() => ({
      size: Math.random() * 5 + 2,
      top: Math.random() * 100,
      left: Math.random() * 100,
      dy: (Math.random() - 0.5) * 100,
      dx: (Math.random() - 0.5) * 50,
      dur: Math.random() * 10 + 10,
    }));
  }, []);

  return (
    <div className="min-h-screen font-sans text-white bg-gradient-to-br from-slate-900 via-gray-800 to-indigo-900">
      {/* HEADER */}
      <header
        id="app-header"
        className="w-full bg-slate-800/70 backdrop-blur-lg shadow-sm sticky top-0 z-50 border-b border-slate-700 px-4 py-2 transition-all duration-300"
      >
        <div className="relative flex flex-col md:flex-row items-center md:justify-between w-full gap-4 md:gap-0">
          {/* MOBILE header */}
          <div className="flex justify-between items-center w-full md:hidden">
            <button
              onClick={() => {
                setShowLangMenu(false);
                setIsMobileMenuOpen((v) => !v);
              }}
              className="text-white text-2xl transition-transform duration-300"
              aria-label="Toggle menu"
              aria-expanded={isMobileMenuOpen}
            >
              {isMobileMenuOpen ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              ) : (
                <FaBars />
              )}
            </button>

            <img
              src="/stt1.png"
              alt="Sweet Trading"
              className="h-10 w-auto cursor-pointer"
              style={{ background: "transparent", mixBlendMode: "normal", filter: "none" }}
              onClick={() => {
                window.scrollTo({ top: 0, behavior: "smooth" });
                setIsMobileMenuOpen(false);
              }}
            />

            {/* MOBILE language menu */}
            <div className="relative" ref={mobileLangMenuRef}>
              <button
                onClick={() => setShowLangMenu((v) => !v)}
                className="p-1 rounded text-white hover:bg-slate-700/50 focus:outline-none focus:ring-2 focus:ring-slate-500"
                aria-label="Sprache wählen"
                aria-expanded={showLangMenu}
                aria-haspopup="menu"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="w-6 h-6"
                >
                  <circle cx="12" cy="12" r="10" />
                  <line x1="2" y1="12" x2="22" y2="12" />
                  <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
                </svg>
              </button>

              {showLangMenu && (
                <div
                  role="menu"
                  className="absolute right-0 mt-1 bg-slate-800 border border-slate-600 rounded-md shadow-lg text-white z-50 overflow-hidden"
                >
                  {LANGS.map((lang) => (
                    <button
                      key={`mobile-${lang.code}`}
                      role="menuitem"
                      onClick={() => {
                        setShowLangMenu(false);
                        window.location.href = lang.href;
                      }}
                      className="px-2 py-1 w-full text-left hover:bg-slate-700 flex items-center gap-2 text-sm"
                    >
                      <span className="text-base leading-none">{lang.flag}</span>
                      <span className="font-semibold">{lang.label}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* MOBILE slideout menu */}
          <AnimatePresence>
            {isMobileMenuOpen && (
              <>
                <motion.button
                  type="button"
                  aria-label="Close menu"
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="fixed inset-0 z-40 bg-black/35 backdrop-blur-md"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                />

                <motion.aside
                  role="dialog"
                  aria-modal="true"
                  initial={{ x: -24, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  exit={{ x: -24, opacity: 0 }}
                  transition={{ duration: 0.22, ease: [0.22, 1, 0.36, 1] }}
                  className="fixed left-0 w-[62vw] max-w-[13.5rem] bg-slate-950/85 backdrop-blur-xl rounded-r-xl shadow-lg border border-slate-700/60 z-50 text-sm md:hidden"
                  style={{
                    top: "var(--headerH, 64px)",
                    height: "calc(var(--vh-dynamic, 100svh) - var(--headerH, 64px))",
                    backdropFilter: "blur(18px)",
                    WebkitBackdropFilter: "blur(18px)",
                  }}
                >
                  <div className="flex items-center justify-between px-3 py-2 border-b border-slate-700/70">
                    <span className="text-[11px] uppercase tracking-[0.22em] text-indigo-300/80">
                      Menü
                    </span>
                  </div>

                  <nav className="flex flex-col p-1 overflow-y-auto">
                    {[
                      { label: headerCopy.login, to: "/login" },
                      { label: headerCopy.support, href: "#support" },
                      { label: headerCopy.faq, href: "#faq" },
                      { label: headerCopy.howItWorks, href: "#how-it-works" },
                      { label: headerCopy.bots, href: "#bots" },
                    ].map((item, idx) =>
                      item.to ? (
                        <Link
                          key={idx}
                          to={item.to}
                          onClick={() => setIsMobileMenuOpen(false)}
                          className="px-3 py-2 text-[0.92rem] leading-tight text-white rounded-xl hover:bg-slate-800/60 active:bg-slate-800/80 transition"
                        >
                          {item.label}
                        </Link>
                      ) : (
                        <a
                          key={idx}
                          href={item.href}
                          onClick={() => setIsMobileMenuOpen(false)}
                          className="px-3 py-2 text-[0.92rem] leading-tight text-white rounded-xl hover:bg-slate-800/60 active:bg-slate-800/80 transition"
                        >
                          {item.label}
                        </a>
                      )
                    )}
                  </nav>
                </motion.aside>
              </>
            )}
          </AnimatePresence>

          {/* DESKTOP header */}
          <div className="hidden md:flex justify-between items-center w-full">
            <img
              src={logoST}
              alt="Sweet Trading Logo"
              className="h-10 w-auto cursor-pointer"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            />

            <nav className="flex justify-center flex-1" aria-label="Hauptnavigation">
              <div className="flex gap-6">
                <a href="#support" className="text-white text-lg font-medium hover:underline">
                  {headerCopy.support}
                </a>
                <a href="#faq" className="text-white text-lg font-medium hover:underline">
                  {headerCopy.faq}
                </a>
                <a href="#how-it-works" className="text-white text-lg font-medium hover:underline">
                  {headerCopy.howItWorks}
                </a>
                <a href="#bots" className="text-white text-lg font-medium hover:underline">
                  {headerCopy.bots}
                </a>
                <Link to="/login" className="text-white text-lg font-medium hover:underline">
                  {headerCopy.login}
                </Link>
              </div>
            </nav>

            {/* DESKTOP language dropdown */}
            <div className="relative ml-4" ref={desktopLangMenuRef}>
              <button
                onClick={() => setShowLangMenu((v) => !v)}
                className="text-2xl"
                aria-label="Sprache wählen"
                aria-expanded={showLangMenu}
              >
                🇩🇪
              </button>

              {showLangMenu && (
                <div className="absolute right-0 mt-2 bg-slate-800 border border-slate-600 rounded shadow text-white z-50 overflow-hidden">
                  {LANGS.map((lang) => (
                    <button
                      key={`desktop-${lang.code}`}
                      onClick={() => {
                        setShowLangMenu(false);
                        window.location.href = lang.href;
                      }}
                      className="px-4 py-2 hover:bg-slate-700 w-full text-xl text-left flex items-center gap-2"
                    >
                      <span>{lang.flag}</span>
                      <span>{lang.label}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </header>

      {/* HERO */}
      <section
        className="relative flex items-center justify-center w-full px-4 py-8 sm:py-12 overflow-x-hidden"
        style={{
          minHeight: isIOS
            ? "var(--vh-locked-safe, var(--vh-locked, 100vh))"
            : "var(--vh-dynamic, 100svh)",
        }}
      >
        <div className="absolute inset-0 w-full h-full z-0 overflow-hidden pointer-events-none">
          {isMobile ? (
            <video
              className="w-full h-full object-cover"
              autoPlay
              muted
              playsInline
              loop
              preload="auto"
              disablePictureInPicture
            >
              <source src="/provatelofono.mov" type="video/quicktime" />
              <img src="/performance.jpg" alt="Background" />
            </video>
          ) : (
            <video
              className="w-full h-full object-cover"
              autoPlay
              muted
              playsInline
              preload="auto"
              loop
              disablePictureInPicture
            >
              <source src="/graficoS.mp4" type="video/mp4" />
              <source src="/graficoS.webm" type="video/webm" />
              <img src="/performance.jpg" alt="Background" />
            </video>
          )}
        </div>

        <div className="absolute inset-0 bg-gradient-to-b from-black/50 to-black/70 z-0 pointer-events-none" />

        <div className="relative z-10 flex flex-col items-center text-center w-full px-2 max-w-[95vw]">
          <motion.h1
            className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-white leading-tight px-2"
            style={{ textShadow: "0 2px 10px rgba(0,0,0,0.5)", lineHeight: "1.2" }}
            initial={{ opacity: 0, y: -20 }}
            animate={{
              opacity: 1,
              y: 0,
              textShadow: [
                "0 2px 10px rgba(0,0,0,0.5)",
                "0 2px 20px rgba(255,255,255,0.3)",
                "0 2px 10px rgba(0,0,0,0.5)",
              ],
            }}
            transition={{
              duration: 0.8,
              textShadow: { duration: 4, repeat: Infinity, repeatType: "reverse" },
            }}
          >
            <span className="bg-gradient-to-r from-white via-gray-100 to-gray-300 bg-clip-text text-transparent">
              {heroCopy.title}
            </span>
          </motion.h1>

          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.6 }}
            className="relative px-2 mt-4"
          >
            <motion.p className="text-lg sm:text-xl text-white/90 font-medium leading-snug mx-auto text-center max-w-[90%]">
              <span className="bg-gradient-to-r from-white to-gray-200 bg-clip-text text-transparent">
                {heroCopy.subtitle}
              </span>
            </motion.p>
          </motion.div>

          <a
            href={heroCopy.buttonLink}
            className="mt-8"
            onClick={(e) => {
              e.preventDefault();
              const target = document.getElementById("promo-purchase");
              target?.scrollIntoView({ behavior: "smooth" });
            }}
          >
            <motion.button
              className="bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-500 hover:to-purple-500 text-white px-8 py-3 rounded-lg font-semibold text-base shadow-lg transition-all duration-300"
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1, boxShadow: "0 4px 15px rgba(99, 102, 241, 0.4)" }}
              whileHover={{ scale: 1.05, boxShadow: "0 6px 20px rgba(99, 102, 241, 0.6)" }}
              whileTap={{ scale: 0.98 }}
            >
              {heroCopy.buttonText}
            </motion.button>
          </a>
        </div>
      </section>

      {/* CLOCK SECTION */}
      <section
        ref={clockRef}
        className="relative flex flex-col items-center justify-center py-20 px-6 bg-gradient-to-br from-slate-900 via-gray-900 to-indigo-900/90 text-white text-center overflow-hidden"
      >
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {clockParticles.map((p, i) => (
            <motion.div
              key={i}
              className="absolute rounded-full bg-indigo-400/20"
              style={{
                width: `${p.size}px`,
                height: `${p.size}px`,
                top: `${p.top}%`,
                left: `${p.left}%`,
              }}
              animate={{ y: [0, p.dy], x: [0, p.dx], opacity: [0.2, 0.8, 0.2] }}
              transition={{ duration: p.dur, repeat: Infinity, ease: "easeInOut" }}
            />
          ))}
          <div className="absolute top-1/4 left-1/4 w-64 h-64 rounded-full bg-indigo-900/20 blur-[80px]" />
          <div className="absolute bottom-1/3 right-1/4 w-48 h-48 rounded-full bg-slate-700/10 blur-[60px]" />
        </div>

        <motion.div
          className="mb-16 w-full text-center relative z-10"
          initial="hidden"
          animate={clockInView ? "visible" : "hidden"}
          variants={{ hidden: {}, visible: { transition: { staggerChildren: 0.12 } } }}
        >
          <motion.div
            variants={clockItemVariants}
            className="text-[0.7rem] sm:text-xs font-semibold tracking-[0.2em] uppercase text-indigo-300/80 mb-4"
          >
            {clockCopy.title}
          </motion.div>

          <motion.h2
            variants={clockItemVariants}
            className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight mb-2 leading-tight text-white max-w-4xl mx-auto"
          >
            <span className="bg-gradient-to-r from-white via-indigo-200 to-indigo-400 bg-clip-text text-transparent">
              {clockCopy.line1}
            </span>
          </motion.h2>

          <motion.h2
            variants={clockItemVariants}
            className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight mb-6 leading-tight text-white max-w-4xl mx-auto"
          >
            <span className="bg-gradient-to-r from-indigo-400 to-cyan-400 bg-clip-text text-transparent">
              {clockCopy.line2}
            </span>
          </motion.h2>

          <motion.div
            variants={clockUnderlineVariants}
            className="w-24 h-1 mx-auto bg-gradient-to-r from-indigo-500/60 to-cyan-500/60 rounded-full origin-center"
          />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 18, scale: 0.96 }}
          animate={clockInView ? { opacity: 1, y: 0, scale: 1 } : { opacity: 0, y: 18, scale: 0.96 }}
          transition={{ delay: 0.35, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
          className="relative z-10"
        >
          <ClockWidget />
        </motion.div>
      </section>

      {/* WHY SECTION */}
      {isMobile ? <WhyMobile whyCopy={whyCopy} iconMap={iconMap} /> : <WhyTabs whyCopy={whyCopy} iconMap={iconMap} />}

      {/* PROCESS */}
      <section
        id="how-it-works"
        className="py-12 md:py-28 px-4 md:px-6 bg-gradient-to-br from-slate-900 via-gray-800 to-indigo-900"
        style={{
          scrollSnapAlign: "none",
          overflowAnchor: "none",
          minHeight: "calc(100dvh - var(--headerH, 0px))",
          scrollMarginTop: "calc(var(--headerH, 0px) + 16px)",
        }}
      >
        <div className="max-w-5xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center mb-12 md:mb-20"
          >
            <h2 className="text-3xl md:text-5xl font-bold text-indigo-200 mb-4 md:mb-6">
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-indigo-300">
                {content.title}
              </span>
            </h2>
            <p className="text-lg md:text-xl text-indigo-300 max-w-3xl mx-auto">{content.subtitle}</p>
          </motion.div>

          <div className="relative" style={{ contain: "layout paint", transform: "translateZ(0)" }}>
            <div className="absolute left-4 md:left-1/2 h-full w-0.5 md:w-1 bg-gradient-to-b from-indigo-500 via-purple-500 to-pink-500 md:transform md:-translate-x-1/2 shadow-lg shadow-indigo-500/50"></div>
            <div className="absolute left-4 md:left-1/2 top-0 w-3 h-3 md:w-4 md:h-4 rounded-full bg-pink-400 md:transform md:-translate-x-1/2 shadow-lg shadow-pink-400/50"></div>
            <div className="absolute left-4 md:left-1/2 top-1/2 w-3 h-3 md:w-4 md:h-4 rounded-full bg-purple-400 md:transform md:-translate-x-1/2 shadow-lg shadow-purple-400/50"></div>
            <div className="absolute left-4 md:left-1/2 bottom-0 w-3 h-3 md:w-4 md:h-4 rounded-full bg-indigo-400 md:transform md:-translate-x-1/2 shadow-lg shadow-indigo-400/50"></div>

            {/* STEP 1 */}
            {safeSteps[0] && (
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                viewport={{ once: true }}
                className="flex items-center mb-16 md:mb-24 pl-8 md:pl-0"
              >
                <div className="z-10 flex-shrink-0 w-12 h-12 md:w-16 md:h-16 rounded-full bg-gradient-to-br from-pink-500 to-indigo-600 border-2 md:border-4 border-indigo-300 flex items-center justify-center text-white font-bold text-xl md:text-2xl mr-4 md:mr-8 ml-0 md:ml-auto shadow-lg shadow-pink-500/30">
                  {safeSteps[0].number}
                </div>
                <div className="bg-slate-800/70 backdrop-blur-sm border border-indigo-500/30 md:border-2 rounded-xl md:rounded-2xl p-4 md:p-8 w-full max-w-md md:max-w-lg text-left md:text-right shadow-lg md:shadow-xl shadow-indigo-500/10 hover:shadow-pink-500/20 transition-all duration-300 hover:border-indigo-400/50">
                  <h3 className="text-xl md:text-2xl font-bold text-white mb-2 md:mb-3 bg-clip-text text-transparent bg-gradient-to-r from-pink-400 to-indigo-300">
                    {safeSteps[0].title}
                  </h3>
                  <p className="text-sm md:text-lg text-indigo-200">{safeSteps[0].description}</p>
                  <div className="mt-3 md:mt-4 flex justify-start md:justify-end">
                    <span className="inline-flex items-center px-2 py-1 md:px-3 md:py-1 rounded-full text-xs md:text-sm font-medium bg-indigo-900/50 text-indigo-200 border border-indigo-700">
                      <FaBolt className="w-3 h-3 md:w-4 md:h-4 mr-1" /> {safeSteps[0].timeLabel}
                    </span>
                  </div>
                </div>
              </motion.div>
            )}

            {/* STEP 2 */}
            {safeSteps[1] && (
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                viewport={{ once: true }}
                className="flex items-center mb-16 md:mb-24 pl-8 md:pl-0 relative"
              >
                <div className="absolute left-6 md:left-1/2 z-10 w-12 h-12 md:w-16 md:h-16 rounded-full bg-gradient-to-br from-purple-500 to-indigo-600 border-2 md:border-4 border-indigo-300 flex items-center justify-center text-white font-bold text-xl md:text-2xl shadow-lg shadow-purple-500/30 md:transform md:-translate-x-1/2 transform-none md:ml-2">
                  {safeSteps[1].number}
                </div>

                <div className="ml-20 md:ml-0 bg-slate-800/70 backdrop-blur-sm border border-indigo-500/30 md:border-2 rounded-xl md:rounded-2xl p-4 md:p-8 w-full max-w-md md:max-w-lg text-left shadow-lg md:shadow-xl shadow-indigo-500/10 hover:shadow-purple-500/20 transition-all duration-300 hover:border-indigo-400/50">
                  <h3 className="text-xl md:text-2xl font-bold text-white mb-2 md:mb-3 bg-clip-text text-transparent bg-gradient-to-r from-purple-400 to-indigo-300">
                    {safeSteps[1].title}
                  </h3>
                  <p className="text-sm md:text-lg text-indigo-200">{safeSteps[1].description}</p>
                  <div className="mt-3 md:mt-4 flex justify-start">
                    <span className="inline-flex items-center px-2 py-1 md:px-3 md:py-1 rounded-full text-xs md:text-sm font-medium bg-indigo-900/50 text-indigo-200 border border-indigo-700">
                      <FaBolt className="w-3 h-3 md:w-4 md:h-4 mr-1" /> {safeSteps[1].timeLabel}
                    </span>
                  </div>
                </div>
              </motion.div>
            )}

            {/* STEP 3 */}
            {safeSteps[2] && (
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.6 }}
                viewport={{ once: true }}
                className="flex items-center pl-8 md:pl-0"
              >
                <div className="z-10 flex-shrink-0 w-12 h-12 md:w-16 md:h-16 rounded-full bg-gradient-to-br from-indigo-500 to-blue-600 border-2 md:border-4 border-indigo-300 flex items-center justify-center text-white font-bold text-xl md:text-2xl mr-4 md:mr-8 ml-0 md:ml-auto shadow-lg shadow-indigo-500/30">
                  {safeSteps[2].number}
                </div>
                <div className="bg-slate-800/70 backdrop-blur-sm border border-indigo-500/30 md:border-2 rounded-xl md:rounded-2xl p-4 md:p-8 w-full max-w-md md:max-w-lg text-left md:text-right shadow-lg md:shadow-xl shadow-indigo-500/10 hover:shadow-blue-500/20 transition-all duration-300 hover:border-indigo-400/50">
                  <h3 className="text-xl md:text-2xl font-bold text-white mb-2 md:mb-3 bg-clip-text text-transparent bg-gradient-to-r from-indigo-400 to-blue-300">
                    {safeSteps[2].title}
                  </h3>
                  <p className="text-sm md:text-lg text-indigo-200">{safeSteps[2].description}</p>
                  <div className="mt-3 md:mt-4 flex justify-start md:justify-end">
                    <span className="inline-flex items-center px-2 py-1 md:px-3 md:py-1 rounded-full text-xs md:text-sm font-medium bg-indigo-900/50 text-indigo-200 border border-indigo-700">
                      <FaStar className="w-3 h-3 md:w-4 md:h-4 mr-1" /> {safeSteps[2].timeLabel}
                    </span>
                  </div>
                </div>
              </motion.div>
            )}
          </div>
        </div>
      </section>

      {/* PROMO */}
      <section
        id="promo-purchase"
        className="relative py-8 sm:py-12 md:py-20 px-4 sm:px-6 bg-gradient-to-br from-slate-900 via-gray-800 to-indigo-900 overflow-hidden"
        style={{ scrollMarginTop: "calc(var(--headerH, 0px) + 16px)" }}
      >
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-1/2 h-1/3 bg-gradient-to-br from-indigo-900/50 to-transparent"></div>
          <div className="absolute bottom-0 right-0 w-1/2 h-1/3 bg-gradient-to-tl from-purple-900/50 to-transparent"></div>
        </div>

        <div className="relative max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true, margin: "-50px" }}
            className="text-center mb-6 sm:mb-8"
          >
            <span className="inline-block bg-indigo-600/90 text-white text-[0.65rem] font-medium px-2.5 py-1 rounded-full mb-2">
              {promoCopy.badge}
            </span>
            <h2 className="text-2xl sm:text-3xl font-bold text-white mb-1.5">
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-indigo-300 to-purple-300">
                {promoCopy.title}
              </span>
            </h2>
            <p
              className="text-xs sm:text-sm text-indigo-200/90 max-w-[16rem] mx-auto"
              dangerouslySetInnerHTML={{ __html: promoCopy.subtitle }}
            />
          </motion.div>

          <div className="flex flex-col gap-4 sm:gap-5 lg:grid lg:grid-cols-2 lg:gap-6">
            {/* OFFER CARD */}
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true, margin: "-50px" }}
              className="bg-slate-800/90 backdrop-blur-sm rounded-xl border border-indigo-500/30 p-4 sm:p-5 shadow-lg hover:shadow-indigo-500/10 transition-all"
            >
              <div className="flex justify-between items-start mb-3">
                <div>
                  <h3 className="text-base font-bold text-white">{promoCopy.cardTitle}</h3>
                  <p className="text-[0.7rem] text-indigo-300/80">{promoCopy.cardSubtitle}</p>
                </div>
                <span className="bg-green-600/20 text-green-300 text-[0.6rem] font-semibold px-1.5 py-0.5 rounded-full">
                  {promoCopy.newBadge}
                </span>
              </div>

              <div className="mb-3">
                <div className="text-xl font-bold text-white">
                  <span className="line-through text-gray-400/80 text-sm mr-1">{promoCopy.oldPrice}</span>
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-cyan-400">
                    {promoCopy.newPrice}
                  </span>
                </div>
                <p className="text-[0.7rem] text-indigo-300/70 mt-0.5">{promoCopy.limitedNote}</p>
              </div>

              <ul className="text-xs sm:text-[0.8rem] text-indigo-200/80 space-y-1.5 mb-4">
                {promoCopy.features?.map((item, i) => (
                  <li key={i} className="flex items-start">
                    <svg className="w-3.5 h-3.5 text-green-400/90 mr-1.5 mt-px flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M5 13l4 4L19 7" />
                    </svg>
                    {item}
                  </li>
                ))}
              </ul>

              <button
                onClick={() => {
                  const el = document.getElementById("bots");
                  el?.scrollIntoView({ behavior: "smooth" });
                }}
                className="w-full bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-500 hover:to-purple-500 text-white font-medium text-center py-2.5 rounded-lg text-xs sm:text-sm transition-all duration-300 active:scale-[0.98]"
              >
                {promoCopy.button}
              </button>
            </motion.div>

            {/* PROMO DETAILS CARD */}
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              viewport={{ once: true, margin: "-50px" }}
              className="bg-slate-800/60 border border-indigo-500/20 rounded-lg p-4 sm:p-5 space-y-3"
            >
              <h3 className="text-sm font-semibold text-white">{promoCopy.promoTitle}</h3>
              <p
                className="text-xs text-indigo-200/80 leading-relaxed"
                dangerouslySetInnerHTML={{ __html: promoCopy.promoText }}
              />
              <div className="flex items-center text-[0.65rem] text-indigo-300/80">
                <svg className="w-3.5 h-3.5 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                {promoCopy.endsSoon}
              </div>

              <ul className="text-xs space-y-1 pt-1.5">
                {promoCopy.benefits?.map((item, i) => (
                  <li key={i} className="text-indigo-200/80">
                    {item}
                  </li>
                ))}
              </ul>

              <p className="text-[0.6rem] text-center text-indigo-400/70 border-t border-indigo-500/20 pt-2">
                {promoCopy.guarantee}
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* BOTS / PLANS */}
      <section
        id="bots"
        className="py-12 px-4 sm:px-6 bg-gradient-to-br from-slate-900 to-indigo-900"
        style={{ scrollMarginTop: "calc(var(--headerH, 0px) + 16px)" }}
      >
        <div className="max-w-6xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-center mb-10 sm:mb-16"
          >
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-3 sm:mb-4 leading-tight">
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-indigo-300 to-purple-300">
                {compareCopy.planTitle} &amp; {comingCopy.title}
              </span>
            </h2>
            <p className="text-sm sm:text-lg text-indigo-200 max-w-xl mx-auto leading-relaxed">
              {compareCopy.planTSubtitle}
            </p>
          </motion.div>

          <div className="flex flex-col gap-4 md:gap-6 lg:grid lg:grid-cols-2 lg:gap-8 lg:max-w-4xl lg:mx-auto">
            {/* CANDY BOT STANDARD */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true, margin: "-100px" }}
            >
              <motion.div
                whileHover={{ y: -3 }}
                className="bg-gradient-to-br from-purple-900/50 to-indigo-900/50 border border-purple-400/30 rounded-xl px-4 py-5 shadow-lg relative z-10"
              >
                <div className="absolute top-0 right-0 bg-gradient-to-r from-pink-500 to-purple-600 text-white text-[10px] font-bold px-2 py-1 rounded-bl-md rounded-tr-md">
                  {compareCopy.offerNote}
                </div>

                <div className="mb-3">
                  <h3 className="text-lg font-bold text-white leading-tight">{compareCopy.planTitle}</h3>
                  <p className="text-purple-300 text-xs mt-1">{compareCopy.planSubtitle}</p>
                </div>

                <div className="mb-4">
                  <div className="flex items-end gap-1">
                    <div className="text-2xl font-bold text-white">{compareCopy.priceFree}</div>
                    <div className="text-gray-400 line-through text-sm">{compareCopy.priceOld}</div>
                  </div>
                  <p className="text-purple-300 text-xs">{compareCopy.offerNote}</p>
                </div>

                <ul className="space-y-2 text-xs mb-5">
                  {compareCopy.features?.map((item, i) => (
                    <li key={i} className="flex items-start text-purple-100">
                      <svg className="w-3.5 h-3.5 text-pink-400 mr-2 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                      </svg>
                      <span className="leading-tight">{item}</span>
                    </li>
                  ))}
                </ul>

                <button
                  onClick={() => setShowPopup(true)}
                  className="w-full bg-gradient-to-r from-pink-500 to-purple-600 hover:from-pink-600 hover:to-purple-700 text-white font-bold py-2.5 rounded-md shadow-md text-xs sm:text-sm transition-all duration-200 active:scale-95"
                >
                  {compareCopy.button}
                </button>
              </motion.div>
            </motion.div>

            {/* CANDY BOT PRO COMING SOON */}
            <motion.div
              whileHover={{ y: -3 }}
              className="bg-slate-800/80 border border-indigo-500/20 rounded-xl px-4 py-5 shadow-md relative overflow-hidden"
            >
              <div className="absolute top-0 right-0 bg-amber-500 text-amber-900 text-[10px] font-bold px-2 py-1 rounded-bl-md rounded-tr-md">
                {comingCopy.badge}
              </div>

              <div className="opacity-80">
                <div className="mb-3">
                  <h3 className="text-lg font-bold text-white leading-tight">{comingCopy.title}</h3>
                  <p className="text-indigo-300 text-xs mt-1">{comingCopy.subtitle}</p>
                </div>

                <div className="mb-4">
                  <div className="text-2xl font-bold text-white mb-1">{comingCopy.priceLabel}</div>
                  <p className="text-indigo-300 text-xs">{comingCopy.priceDescription}</p>
                </div>

                <ul className="space-y-2 text-xs mb-5">
                  {comingCopy.features?.map((item, i) => (
                    <li key={i} className="flex items-start text-indigo-300">
                      <svg className="w-3.5 h-3.5 text-indigo-400 mr-2 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                      </svg>
                      <span className="leading-tight">{item}</span>
                    </li>
                  ))}
                </ul>

                <button
                  className="w-full bg-slate-700/70 text-indigo-300 font-medium py-2.5 rounded-md cursor-not-allowed text-xs sm:text-sm"
                  disabled
                >
                  {comingCopy.buttonText}
                </button>
              </div>
            </motion.div>
          </div>

          {/* FAQ */}
          <section
            id="faq"
            style={{
              marginTop: "6rem",
              padding: "48px 16px",
              background: "linear-gradient(135deg, #0f172a, #1e293b, #4338ca)",
              position: "relative",
              overflow: "hidden",
              color: "white",
              scrollMarginTop: "calc(var(--headerH, 0px) + 16px)",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: -100,
                right: -100,
                width: 300,
                height: 300,
                borderRadius: "50%",
                background: "radial-gradient(circle, rgba(99,102,241,0.2) 0%, rgba(0,0,0,0) 70%)",
                opacity: 0.3,
                zIndex: 0,
              }}
            />
            <div
              style={{
                position: "absolute",
                bottom: -50,
                left: -50,
                width: 200,
                height: 200,
                borderRadius: "50%",
                background: "radial-gradient(circle, rgba(139,92,246,0.15) 0%, rgba(0,0,0,0) 70%)",
                opacity: 0.2,
                zIndex: 0,
              }}
            />

            <div style={{ maxWidth: "1200px", margin: "0 auto", position: "relative", zIndex: 1 }}>
              <div style={{ textAlign: "center", marginBottom: "32px" }}>
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "16px" }}>
                  <div
                    style={{
                      fontSize: "40px",
                      color: "#a78bfa",
                      background: "rgba(99,102,241,0.2)",
                      padding: "16px",
                      borderRadius: "50%",
                      width: "72px",
                      height: "72px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    ?
                  </div>
                  <h2>{faqCopy.title}</h2>
                  <p>{faqCopy.description}</p>
                </div>
              </div>

              <div style={{ borderRadius: "8px", overflow: "hidden", boxShadow: "0 2px 10px rgba(67,56,202,0.3)" }}>
                {faqCopy.items?.map((item, index) => (
                  <div
                    key={index}
                    style={{
                      background: "#1e293b",
                      borderBottom: "1px solid #4338ca",
                      transition: "all 0.3s",
                    }}
                  >
                    <button
                      onClick={(e) => {
                        const answer = e.currentTarget.nextElementSibling;
                        if (!answer) return;
                        const isOpen = answer.style.maxHeight === "500px";
                        answer.style.maxHeight = isOpen ? "0" : "500px";
                        answer.style.opacity = isOpen ? "0" : "1";
                        answer.style.padding = isOpen ? "0 16px" : "0 16px 16px 16px";
                        const svg = e.currentTarget.querySelector("svg");
                        svg?.style.setProperty("transform", isOpen ? "rotate(0deg)" : "rotate(45deg)");
                      }}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        padding: "16px",
                        background: "transparent",
                        border: "none",
                        cursor: "pointer",
                        textAlign: "left",
                        color: "white",
                      }}
                    >
                      <span style={{ fontSize: "16px", fontWeight: 500, color: "white", transition: "color 0.3s" }}>
                        {item.question}
                      </span>
                      <svg
                        style={{
                          width: "20px",
                          height: "20px",
                          color: "#a78bfa",
                          transition: "transform 0.3s",
                          flexShrink: 0,
                        }}
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                      </svg>
                    </button>

                    <div
                      style={{
                        overflow: "hidden",
                        maxHeight: "0",
                        opacity: "0",
                        padding: "0 16px",
                        transition: "all 0.3s ease-in-out",
                      }}
                    >
                      <p style={{ color: "#c7d2fe", margin: 0 }}>{item.answer}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </div>
      </section>

      {/* BROKER / FOREXMART SECTION (DE) */}
      <section className="py-12 sm:py-16 relative overflow-hidden border-t border-b border-gray-800/50">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              typeof ForexMw !== "undefined" && ForexMw
                ? `url(${ForexMw})`
                : "linear-gradient(135deg, rgba(0,102,204,0.25), rgba(0,0,40,0.9))",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            filter: "brightness(0.7) saturate(1.1)",
          }}
        />

        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#001a3d]/40 to-[#000814]/90" />

        <div className="absolute -top-24 -right-24 h-64 w-64 rounded-full bg-sky-500/10 blur-3xl" />
        <div className="absolute -bottom-28 -left-28 h-72 w-72 rounded-full bg-blue-400/10 blur-3xl" />

        <div className="relative container mx-auto px-4 sm:px-6 lg:px-8 z-10 text-center">
          <h2 className="max-w-3xl mx-auto text-2xl sm:text-3xl lg:text-4xl font-extrabold text-white leading-tight tracking-tight">
            {brokerCopy.titleA}{" "}
            <span className="text-sky-400">{brokerCopy.titleB}</span>
          </h2>

          <p className="mt-3 sm:mt-4 text-base sm:text-lg lg:text-xl text-gray-300 max-w-2xl mx-auto">
            {brokerCopy.subtitle}
          </p>

          <div className="mt-10 sm:mt-14 flex flex-col items-center justify-center">
            <div className="p-4 sm:p-5 bg-white/10 rounded-2xl border border-white/10 hover:border-sky-500/50 transition">
              {typeof forexmartLogo !== "undefined" ? (
                <img src={forexmartLogo} alt="ForexMart Logo" className="h-14 sm:h-20 w-auto" />
              ) : (
                <div className="h-14 sm:h-20 px-6 flex items-center justify-center text-white/90 font-semibold">
                  ForexMart
                </div>
              )}
            </div>

            <p className="mt-3 sm:mt-4 text-xs sm:text-sm text-gray-400 max-w-[300px] sm:max-w-sm">
              <span className="text-gray-200 font-medium">{brokerCopy.captionA}</span>{" "}
              <span className="opacity-70">{brokerCopy.captionB}</span>
            </p>
          </div>

          <p className="mt-10 text-[10px] sm:text-xs text-gray-500 max-w-3xl mx-auto">
            {brokerCopy.microDisclaimer}
          </p>
        </div>
      </section>

      {/* LEGAL & SUPPORT */}
      <div className="flex justify-center items-center mt-12">
        <div className="p-6 w-full max-w-md">
          <h3 className="text-2xl font-bold text-gray-100 mb-8 text-center">{legalCopy.sectionTitle}</h3>

          <div className="space-y-5">
            <div className="flex flex-col items-center space-y-4 py-3">
              <div className="flex space-x-6">
                <a href="/terms" className="text-gray-400 hover:text-blue-400 transition-colors flex items-center">
                  <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  {legalCopy.terms}
                </a>
                <a href="/privacy" className="text-gray-400 hover:text-blue-400 transition-colors flex items-center">
                  <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                  </svg>
                  {legalCopy.privacy}
                </a>
              </div>
            </div>

            <div className="flex flex-col items-center space-y-4 pt-5 mt-5 border-t border-gray-700">
              <div className="flex flex-col items-center">
                <p className="text-sm text-gray-400 mb-1">{legalCopy.emailLabel}</p>
                <a
                  href={`mailto:${legalCopy.email}`}
                  className="text-blue-400 hover:text-white text-sm text-center break-all"
                >
                  {legalCopy.email}
                </a>
              </div>

              <div className="flex flex-col items-center mt-6">
                <p className="text-sm text-gray-400 mb-2">{legalCopy.chatLabel}</p>
                <a
                  href="https://t.me/assistenceST"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-blue-500 hover:bg-blue-600 text-white rounded-full p-3 transition-colors"
                >
                  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M9.74 15.29l-.39 3.48c.56 0 .8-.24 1.1-.53l2.64-2.5 5.47 4.01c1.01.56 1.73.27 1.99-.93l3.61-16.78c.33-1.53-.56-2.13-1.54-1.75L1.63 9.71c-1.49.58-1.47 1.41-.27 1.79l4.62 1.44 10.73-6.78c.51-.31.97-.14.59.2l-8.69 7.93z" />
                  </svg>
                </a>
                <p className="text-xs text-gray-500 mt-2">{legalCopy.replyTime}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* PAYMENT METHODS */}
      <section className="flex flex-wrap justify-center gap-4 py-6 max-w-4xl mx-auto mt-12 px-4 overflow-x-hidden">
        {[option1, option4, option6, option7, option8, option9, option10, option11].map((icon, idx) => (
          <img key={idx} src={icon} alt={`Payment method ${idx + 1}`} className="h-5 w-auto sm:h-6 md:h-8" />
        ))}
      </section>

      {/* FOOTER */}
      <footer
        id="support"
        className="text-center py-12 bg-slate-900 text-indigo-300 text-sm border-t border-slate-700"
        style={{ scrollMarginTop: "calc(var(--headerH, 0px) + 16px)" }}
      >
        {footerCopy.copyright}
        <p className="mt-4 max-w-5xl mx-auto px-4 text-xs text-indigo-400">{footerCopy.disclaimer}</p>
      </footer>

      {/* POPUP (uno solo) */}
     {/* Reused popup */}
<PurchasePopup
  open={showPopup}
  product={compareCopy.planTitle}
  onClose={() => setShowPopup(false)}
  onRegister={handleRegister}
  copy={{
    compareSection: DE_COPY.compareSection,
    loader: {
      title: "Validierung…",
      subtitle: "Bitte warten…",
    },
    popup: {
      successTitle: "Registrierung bestätigt",
      successText: "E-Mail gesendet an",
      successNote: "Bitte prüfe auch den Spam-Ordner.",
      close: "Schließen",
      confirmMessage: `Neue Anfrage: ${compareCopy.planTitle}`,
    },
  }}
/>

    </div>
  );
}
